import { render } from "./TickerBar.vue?vue&type=template&id=6722aeba&scoped=true"
import script from "./TickerBar.vue?vue&type=script&lang=js"
export * from "./TickerBar.vue?vue&type=script&lang=js"

import "./TickerBar.vue?vue&type=style&index=0&id=6722aeba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6722aeba"]])

export default __exports__